export const getOrgMediaInfoUrl = "/api/v3/org/:orgId/media/:mediaId";
export const addOrgMediaImagesUrl = "/api/v3/org/:orgId/media/:mediaId/files";
export const downloadOrgMediaPdfReportUrl =
  "/api/v3/org/:orgId/media/:mediaId/export/pdf";
